"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Color = require("color");
var darken = function (percent, color) {
    return Color(color)
        .darken(percent)
        .hex();
};
var lighten = function (percent, color) {
    return Color(color)
        .lighten(percent)
        .hex();
};
var primary = '#00AEEF';
var secondary = '#2A506F';
var tertiary = '#527699';
var quartenary = '#F8F9FD';
var danger = '#FF423D';
var warning = '#FCA321';
var success = '#1AC135';
var info = '#1496E1';
var colors = {
    primary: {
        main: primary,
        light: lighten(0.1, primary),
        dark: darken(0.1, primary),
    },
    secondary: {
        main: secondary,
        light: lighten(0.1, secondary),
        dark: darken(0.1, secondary),
    },
    tertiary: {
        main: tertiary,
        light: lighten(0.1, tertiary),
        dark: darken(0.1, tertiary),
    },
    quartenary: {
        main: quartenary,
        light: lighten(0.1, quartenary),
        dark: darken(0.1, quartenary),
    },
    danger: {
        main: danger,
        semilight: lighten(0.2, danger),
        light: lighten(0.55, danger),
        dark: darken(0.2, danger),
    },
    warning: {
        main: warning,
        semilight: lighten(0.2, warning),
        light: lighten(0.7, warning),
        dark: darken(0.2, warning),
    },
    success: {
        main: success,
        semilight: lighten(0.22, success),
        light: lighten(1.25, success),
        dark: darken(0.2, success),
    },
    info: {
        main: info,
        semilight: lighten(0.27, info),
        light: lighten(1, info),
        dark: darken(0.2, info),
    },
    text: {
        main: '#3c3e42',
        light: '#8f9297',
        dark: '#1c1d1e',
    },
    statusIdle: {
        main: '#89c683',
    },
    statusConfiguring: {
        main: '#ffb25e',
    },
    statusUpdating: {
        main: '#75C5F5',
    },
    statusPostProvisioning: {
        main: '#aa96d5',
    },
    statusOffline: {
        main: '#fd7c7c',
    },
    statusInactive: {
        main: '#d3d6db',
    },
    gray: {
        main: '#c6c8c9',
        light: '#f4f4f4',
        dark: '#9f9f9f',
    },
};
var defaultControlHeight = 36;
var emphasizedControlHeight = 48;
exports.breakpoints = ['32em', '48em', '64em', '80em'];
exports.space = [
    0,
    4,
    8,
    16,
    defaultControlHeight,
    emphasizedControlHeight,
    128,
];
exports.fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 72, 96];
exports.weights = [400, 700];
exports.radius = 3;
exports.font = "'Nunito', Arial, sans-serif";
exports.titleFont = "CircularStd, Arial, sans-serif";
exports.monospace = "'Ubuntu Mono', 'Courier New', monospace";
exports.default = {
    breakpoints: exports.breakpoints,
    space: exports.space,
    fontSizes: exports.fontSizes,
    weights: exports.weights,
    font: exports.font,
    titleFont: exports.titleFont,
    monospace: exports.monospace,
    colors: colors,
    radius: exports.radius,
    global: {
        font: {
            family: exports.font,
            size: '14px',
            height: 1.5,
        },
        control: {
            disabled: {
                opacity: 0.4,
            },
            border: {
                radius: '20px',
            },
        },
        colors: {
            focus: '#73AAF5',
        },
    },
    button: {
        height: '38px',
        font: {
            weight: 500,
        },
        border: {
            width: '1px',
            radius: '20px',
            color: colors.text.main,
        },
        padding: {
            horizontal: '30px',
        },
    },
    radioButton: {
        border: {
            color: {
                dark: colors.quartenary.dark,
                light: colors.quartenary.dark,
            },
            width: '1px',
        },
        check: {
            color: {
                dark: 'white',
                light: 'white',
            },
        },
        hover: {
            border: {
                color: {
                    dark: colors.quartenary.dark,
                    light: colors.quartenary.dark,
                },
            },
        },
        icon: { size: '12px' },
        gap: '10px',
        size: '20px',
    },
    layer: {
        container: {
            zIndex: 40,
        },
        zIndex: 30,
    },
    text: {
        medium: {
            size: '14px',
            height: '1.5',
        },
    },
    tab: {
        extend: 'border: none;',
        color: colors.primary.main,
    },
};



//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/rendition/dist/theme.js
// module id = 37
// module chunks = 2